// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Layout Principal ========== */

.KpisUI_view__DsexK {
  min-height: 100%;
}

.KpisUI_layout__LJaDu {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.KpisUI_mainContent__mLRFC {
  flex: 1 1;
  min-width: 0;
}

.KpisUI_content__u2cEb {
  width: 100%;
  padding: 8px 0;
  animation: KpisUI_fadeInContent__nouyt 0.35s ease-out;
}

@keyframes KpisUI_fadeInContent__nouyt {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========== DateFilters ========== */

.KpisUI_container__ayzFI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.KpisUI_tabs__DzRUL {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.KpisUI_tab__fnXKs {
  font-size: 13px;
  font-weight: 500;
  color: #7E7E7E;
  cursor: pointer;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid transparent;
  transition: all 0.25s ease;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.KpisUI_tab__fnXKs:hover {
  background-color: #fff3ec;
  color: var(--orange);
  border-color: #ffe0cc;
}

.KpisUI_activeTab__Kzmfg {
  background-color: var(--orange);
  color: #fff;
  border-color: var(--orange);
}

.KpisUI_activeTab__Kzmfg:hover {
  background-color: var(--orange);
  color: #fff;
  border-color: var(--orange);
}

.KpisUI_disabledTab__b\\+Fs\\+ {
  opacity: 0.6;
  pointer-events: none;
}

.KpisUI_dateLoader__a0Bth {
  display: flex;
  align-items: center;
  margin-left: 4px;
}

.KpisUI_pickers__CliXo {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* ========== NavItems (Sidebar) ========== */

.KpisUI_cardsContainer__PCPG3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.KpisUI_navWrapper__zXRLZ {
  width: 240px;
  min-width: 240px;
  position: sticky;
  top: 24px;
}

.KpisUI_mobileNavToggle__z\\+Vws {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  font-weight: 600;
  color: #383838;
  cursor: pointer;
  margin-bottom: 12px;
}

.KpisUI_card__z4OFu {
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  border-radius: 10px !important;
  border: 1px solid #f0f0f0 !important;
  transition: all 0.25s ease !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.KpisUI_card__z4OFu:hover {
  border-color: #ffe0cc !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.KpisUI_activeCard__n07a0 {
  background-color: var(--orange) !important;
  color: #fff !important;
  border-color: var(--orange) !important;
}

.KpisUI_cardBody__Ig9ME {
  display: flex;
  align-items: center;
  gap: 24px;
}

.KpisUI_cardIcon__y\\+gTT {
  font-size: 16px;
  opacity: 0.85;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.KpisUI_cardLabel__2Cqed {
  flex: 1 1;
  line-height: 1.3;
}

/* ========== Responsive Media Queries ========== */

@media (max-width: 992px) {
  .KpisUI_layout__LJaDu {
    flex-direction: column-reverse;
  }

  .KpisUI_navWrapper__zXRLZ {
    width: 100%;
    min-width: 100%;
    position: static;
  }

  .KpisUI_mobileNavToggle__z\\+Vws {
    display: flex;
  }

  .KpisUI_cardsContainer__PCPG3 {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out, padding 0.3s ease-in-out;
  }

  .KpisUI_cardsContainer__PCPG3.KpisUI_expanded__u4GgP {
    max-height: 600px;
    opacity: 1;
    padding-bottom: 12px;
  }
}

@media (max-width: 576px) {
  .KpisUI_card__z4OFu {
    flex: 1 1 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/kpis/styles/KpisUI.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACI,gBAAgB;AACpB;;AAEA;EACI,aAAa;EACb,SAAS;EACT,uBAAuB;AAC3B;;AAEA;EACI,SAAO;EACP,YAAY;AAChB;;AAEA;EACI,WAAW;EACX,cAAc;EACd,qDAAuC;AAC3C;;AAEA;EACI;IACI,UAAU;IACV,0BAA0B;EAC9B;;EACA;IACI,UAAU;IACV,wBAAwB;EAC5B;AACJ;;AAEA,sCAAsC;;AAEtC;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACnB;;AAEA;EACI,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACvB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACvB;;AAEA;EACI,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;AACzB;;AAEA;EACI,+BAA+B;EAC/B,WAAW;EACX,2BAA2B;AAC/B;;AAEA;EACI,+BAA+B;EAC/B,WAAW;EACX,2BAA2B;AAC/B;;AAEA;EACI,YAAY;EACZ,oBAAoB;AACxB;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AACpB;;AAEA;EACI,aAAa;EACb,SAAS;EACT,mBAAmB;AACvB;;AAEA,6CAA6C;;AAE7C;EACI,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACZ;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACb;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACvB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AACpB;;AAEA;EACI,gCAAgC;EAChC,qDAAqD;AACzD;;AAEA;EACI,0CAA0C;EAC1C,sBAAsB;EACtB,sCAAsC;AAC1C;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS;AACb;;AAEA;EACI,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACvB;;AAEA;EACI,SAAO;EACP,gBAAgB;AACpB;;AAEA,mDAAmD;;AAEnD;EACI;IACI,8BAA8B;EAClC;;EAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;EACpB;;EAEA;IACI,aAAa;EACjB;;EAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,2FAA2F;EAC/F;;EAEA;IACI,iBAAiB;IACjB,UAAU;IACV,oBAAoB;EACxB;AACJ;;AAEA;EACI;IACI,cAAc;EAClB;AACJ","sourcesContent":["/* ========== Layout Principal ========== */\n\n.view {\n    min-height: 100%;\n}\n\n.layout {\n    display: flex;\n    gap: 24px;\n    align-items: flex-start;\n}\n\n.mainContent {\n    flex: 1;\n    min-width: 0;\n}\n\n.content {\n    width: 100%;\n    padding: 8px 0;\n    animation: fadeInContent 0.35s ease-out;\n}\n\n@keyframes fadeInContent {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ========== DateFilters ========== */\n\n.container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.tabs {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.tab {\n    font-size: 13px;\n    font-weight: 500;\n    color: #7E7E7E;\n    cursor: pointer;\n    padding: 6px 16px;\n    border-radius: 20px;\n    border: 1px solid transparent;\n    transition: all 0.25s ease;\n    user-select: none;\n    white-space: nowrap;\n}\n\n.tab:hover {\n    background-color: #fff3ec;\n    color: var(--orange);\n    border-color: #ffe0cc;\n}\n\n.activeTab {\n    background-color: var(--orange);\n    color: #fff;\n    border-color: var(--orange);\n}\n\n.activeTab:hover {\n    background-color: var(--orange);\n    color: #fff;\n    border-color: var(--orange);\n}\n\n.disabledTab {\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n.dateLoader {\n    display: flex;\n    align-items: center;\n    margin-left: 4px;\n}\n\n.pickers {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n/* ========== NavItems (Sidebar) ========== */\n\n.cardsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.navWrapper {\n    width: 240px;\n    min-width: 240px;\n    position: sticky;\n    top: 24px;\n}\n\n.mobileNavToggle {\n    display: none;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    background: #fff;\n    border: 1px solid #f0f0f0;\n    border-radius: 10px;\n    font-weight: 600;\n    color: #383838;\n    cursor: pointer;\n    margin-bottom: 12px;\n}\n\n.card {\n    font-size: 13px;\n    font-weight: 500;\n    text-align: left;\n    border-radius: 10px !important;\n    border: 1px solid #f0f0f0 !important;\n    transition: all 0.25s ease !important;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n}\n\n.card:hover {\n    border-color: #ffe0cc !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n}\n\n.activeCard {\n    background-color: var(--orange) !important;\n    color: #fff !important;\n    border-color: var(--orange) !important;\n}\n\n.cardBody {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.cardIcon {\n    font-size: 16px;\n    opacity: 0.85;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n}\n\n.cardLabel {\n    flex: 1;\n    line-height: 1.3;\n}\n\n/* ========== Responsive Media Queries ========== */\n\n@media (max-width: 992px) {\n    .layout {\n        flex-direction: column-reverse;\n    }\n\n    .navWrapper {\n        width: 100%;\n        min-width: 100%;\n        position: static;\n    }\n\n    .mobileNavToggle {\n        display: flex;\n    }\n\n    .cardsContainer {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        max-height: 0;\n        overflow: hidden;\n        opacity: 0;\n        transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out, padding 0.3s ease-in-out;\n    }\n\n    .cardsContainer.expanded {\n        max-height: 600px;\n        opacity: 1;\n        padding-bottom: 12px;\n    }\n}\n\n@media (max-width: 576px) {\n    .card {\n        flex: 1 1 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `KpisUI_view__DsexK`,
	"layout": `KpisUI_layout__LJaDu`,
	"mainContent": `KpisUI_mainContent__mLRFC`,
	"content": `KpisUI_content__u2cEb`,
	"fadeInContent": `KpisUI_fadeInContent__nouyt`,
	"container": `KpisUI_container__ayzFI`,
	"tabs": `KpisUI_tabs__DzRUL`,
	"tab": `KpisUI_tab__fnXKs`,
	"activeTab": `KpisUI_activeTab__Kzmfg`,
	"disabledTab": `KpisUI_disabledTab__b+Fs+`,
	"dateLoader": `KpisUI_dateLoader__a0Bth`,
	"pickers": `KpisUI_pickers__CliXo`,
	"cardsContainer": `KpisUI_cardsContainer__PCPG3`,
	"navWrapper": `KpisUI_navWrapper__zXRLZ`,
	"mobileNavToggle": `KpisUI_mobileNavToggle__z+Vws`,
	"card": `KpisUI_card__z4OFu`,
	"activeCard": `KpisUI_activeCard__n07a0`,
	"cardBody": `KpisUI_cardBody__Ig9ME`,
	"cardIcon": `KpisUI_cardIcon__y+gTT`,
	"cardLabel": `KpisUI_cardLabel__2Cqed`,
	"expanded": `KpisUI_expanded__u4GgP`
};
export default ___CSS_LOADER_EXPORT___;
